import { MimeType } from '../states';

export const getBase64Image = (img: string): string => {
  return img.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
};

export const addBase64Header = (img: string, format: MimeType): string => {
  return `data:${format};base64,${img}`;
};
